/**
 * API Configuration
 * 
 * Centralized API URL configuration based on environment profile.
 * 
 * Usage:
 *   import { API_BASE_URL } from '../config/api';
 *   fetch(`${API_BASE_URL}/reviews/approved`)
 * 
 * Profiles:
 *   - local: http://localhost:5001/api
 *   - production: https://arvix-creative-backend.vercel.app/api
 */

// Get profile from environment variable (defaults to 'local' for development)
const PROFILE = process.env.REACT_APP_PROFILE || 'local';

// API URLs for each profile
const API_URLS = {
  local: 'http://localhost:5001/api',
  production: 'https://arvix-creative-backend.vercel.app/api',
};

// Get the API base URL based on profile
// If REACT_APP_API_URL is explicitly set, use it; otherwise use profile-based URL
const API_BASE_URL = process.env.REACT_APP_API_URL || API_URLS[PROFILE] || API_URLS.local;

// Export the API base URL
export { API_BASE_URL };

// Export profile for debugging/logging purposes
export const CURRENT_PROFILE = PROFILE;

// Log current configuration in development
if (process.env.NODE_ENV === 'development') {
  console.log(`🔧 API Configuration:
    Profile: ${CURRENT_PROFILE}
    API Base URL: ${API_BASE_URL}
  `);
}
